import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../Icon';
import { trackEvent } from '../../utils/analytics';
import { PHONE } from '../../content/contacts';

/**
 * Заклик у бічній колонці сторінки питань, під змістом.
 *
 * Зміст на десктопі липкий, тож цей блок їде разом із ним через усю
 * сторінку: людина, яка не знайшла свого питання в третьому розділі, не
 * мусить гортати до кінця, щоб його поставити. Кнопки — на всю ширину
 * колонки одна під одною: у 16–19rem дві поруч не вмістилися б без переносу
 * номера телефону.
 */
const FaqAsk = ({ source = 'faq-sidebar', className = '' }) => (
  <div className={`rounded-2xl border border-teal-100 bg-teal-50/50 p-4 xl:p-5 ${className}`}>
    <p className="font-display text-base font-bold leading-snug text-slate-900">Не знайшли свого питання?</p>
    <p className="mt-1 text-sm leading-relaxed text-slate-600">Досить імені й телефону — решту з’ясуємо в розмові.</p>
    <Link
      to="/kontakty"
      onClick={() => trackEvent('cta_click', source)}
      className="mt-3 flex w-full items-center justify-center gap-2 rounded-lg bg-teal-700 px-4 py-2.5 font-bold text-white hover:bg-teal-800 transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-700 focus-visible:ring-offset-2"
    >
      Поставити запитання
      <Icon name="fa-arrow-right" className="text-sm" />
    </Link>
    <a
      href={PHONE.href}
      onClick={() => trackEvent('contact_channel', `${source}-phone`)}
      className="mt-2 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-slate-300 bg-white px-4 py-2.5 font-bold text-slate-800 hover:border-teal-600 hover:text-teal-800 transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-700 focus-visible:ring-offset-2"
    >
      <Icon name="fa-phone" className="text-teal-700" />
      {PHONE.label}
    </a>
  </div>
);

export default FaqAsk;
